import useIsInSptOnVdpExperiment from '~/hooks/vdp/useIsInSptOnVdpExperiment';
import PriceDetailsWrapper from './PriceDetailsWrapper';
import SptPriceDetails from './SptPriceDetails';

const PriceDetailsSection = ({ ...props }) => {
  const isInSptOnVdpExperiment = useIsInSptOnVdpExperiment();

  return isInSptOnVdpExperiment ? (
    <SptPriceDetails {...props} />
  ) : (
    <PriceDetailsWrapper {...props} />
  );
};

export default PriceDetailsSection;
